import { HEADER, PAGE_3, PAGE_4 } from "./assets";

export const homepage = "/";

export const headerButtons = [
    {
        label: HEADER.BUTTON_1.default,
        id: "frontPage"
    },
    {
        label: HEADER.BUTTON_2.default,
        id: "pageTwo"
    },
    {
        label: HEADER.BUTTON_3.default,
        id: "pageThree"
    },
    {
        label: HEADER.BUTTON_4.default,
        id: "pageFour"
    },
    {
        label: HEADER.BUTTON_5.default,
        id: "pageFive"
    }
];

export const characters = [
    {
        names: [PAGE_3.CHARACTERS_1.default],
        key: "1"
    },
    {
        names: [PAGE_3.CHARACTERS_2.default],
        key: "2"
    },
    {
        names: [PAGE_3.CHARACTERS_3.default],
        key: "3"
    },
    {
        names: [PAGE_3.CHARACTERS_4.default],
        key: "4"
    },
    {
        names: [PAGE_3.CHARACTERS_5.default],
        key: "5"
    },
    {
        names: [PAGE_3.CHARACTERS_6.default],
        key: "6"
    }
];

export const buttons = [
    {
        id: "1",
        button: PAGE_3.ICON_1A.default,
        buttonActive: PAGE_3.ICON_1B.default
    },
    {
        id: "2",
        button: PAGE_3.ICON_2A.default,
        buttonActive: PAGE_3.ICON_2B.default
    },
    {
        id: "3",
        button: PAGE_3.ICON_3A.default,
        buttonActive: PAGE_3.ICON_3B.default
    },
    {
        id: "4",
        button: PAGE_3.ICON_4A.default,
        buttonActive: PAGE_3.ICON_4B.default
    } ,
    {
        id: "5",
        button: PAGE_3.ICON_5A.default,
        buttonActive: PAGE_3.ICON_5B.default
    } ,
    {
        id: "6",
        button: PAGE_3.ICON_6A.default,
        buttonActive: PAGE_3.ICON_6B.default
    } 
];

export const boxes = [
    {
        box: PAGE_3.BOX.default,
        frame: PAGE_3.BOX_FRAME.default
    },
    {
        box: PAGE_3.BOX.default,
        frame: PAGE_3.BOX_FRAME.default
    },
    {
        box: PAGE_3.BOX.default,
        frame: PAGE_3.BOX_FRAME.default
    },
    {
        box: PAGE_3.BOX.default,
        frame: PAGE_3.BOX_FRAME.default
    } 
];

export const images = [
    PAGE_4.IMAGE_1.default, 
    PAGE_4.IMAGE_2.default, 
    PAGE_4.IMAGE_3.default, 
    PAGE_4.IMAGE_4.default, 
    PAGE_4.IMAGE_5.default
];